import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Modal, Button, Dropdown, TextArea, Grid} from 'semantic-ui-react';
import {vehicleMasterRequestStatus} from '../../../../common/constants/lists';
import {cloneDeep} from 'lodash';
import './modalReject.scss';

class ModalReject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
      'statusReject': '',
      'rejectionDescription': '',
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onRejectClick = this.onRejectClick.bind(this);
    this.onChangeRejectText = this.onChangeRejectText.bind(this);
  }

  render() {
    const {modalWasOpen, statusReject, rejectionDescription} = this.state;
    const {code, disabled} = this.props;
    if (!code || disabled) {
      return (
        <Button
          primary
          type='submit'
          disabled
        >
          Rechazar
        </Button>
      );
    }

    return (
      <Modal size='large' onOpen={() => this.fetchData()}
        className='modal-reject'
        open={modalWasOpen}
        trigger={
          <span className='storage-car'>
            <Button
              primary
              type='submit'
            >
              Rechazar
            </Button>
          </span>
        }>

        <Modal.Header>
          ¿Está seguro que desea rechazar la orden {code}?
        </Modal.Header>
        
        <Modal.Content>
          <Modal.Description>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Dropdown selection
                    options={this.getStatusOptions()}
                    search
                    value={statusReject}
                    onChange={(e, {value}) => this.onChangeRejectStatus(value)}
                    placeholder='Seleccione un Estado'
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <div>
                    <strong>Ingrese el motivo de rechazo:</strong>
                  </div>
                  <TextArea
                    rows={10}
                    value={rejectionDescription}
                    onChange={this.onChangeRejectText}
                    maxLength={1000}
                    required
                    autoComplete='off'
                    placeholder='Ingrese el motivo de rechazo'
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick} >
            Cancelar
          </Button>
          <Button
            primary
            onClick={this.onRejectClick.bind(this)}
            disabled = {!rejectionDescription}
          >
            Rechazar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }

  fetchData() {
    const statusOptions = this.getStatusOptions();
    this.setState({
      'modalWasOpen': true,
      'statusReject': statusOptions[0].value,
      'rejectionDescription': '',
    });
  }
  
  getStatusOptions() {
    const options = cloneDeep(vehicleMasterRequestStatus);
    options.pop();
    return options;
  }

  onChangeRejectStatus(value) {
    this.setState({'statusReject': value});
  }

  onChangeRejectText(event) {
    const value = event.target.value;
    this.setState({'rejectionDescription': value});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }
  
  onRejectClick() {
    const {statusReject, rejectionDescription} = this.state;
    const {code} = this.props;
    if (!rejectionDescription) {
      return;
    }
    const data = {
      'state': statusReject,
      'rejectionDescription': rejectionDescription,
    };
    this.props.rejectRequest('REJECT');
    this.props.updateRejectMasterVEH(code, data);
    this.props.goBack();
    this.onCloseModalClick();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'goBack': ownProps.history.goBack,
  };
};

const {
  updateRejectMasterVEH,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  updateRejectMasterVEH,
})(ModalReject));
